import {Swiper, Autoplay, EffectFade, Navigation, Pagination, Thumbs} from 'swiper'
import {loadBlockLazyImages, loadElementLazyImage} from "../helpers/lazy-load";
import {playRive} from "../helpers/rive";
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


gsap.registerPlugin(ScrollTrigger);



$('.js-full-cycle-manufacturing-block').each(function(i, el){
  let block = $(el)
  let pagesArr = block.find('.js-swiper-pagination').data('pages-arr')
  let lastActiveAnimation = ''
  loadElementLazyImage(block.find('.lazy'))

  // left slider
  let leftSwiper = new Swiper(block.find('.js-images-slider')[0], {
    modules: [Autoplay, EffectFade, Navigation, Pagination],
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
  })

  let rightSwiper = new Swiper(block.find('.js-content-slider')[0], {
    modules: [Autoplay, EffectFade, Navigation, Pagination, Thumbs],
    autoplay: {
      delay: 6000,
      disableOnInteraction: true,
    },
    speed: 600,
    //loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
      swiper: leftSwiper,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        //let initClass = index ===0 ? 'hover in' : 'intro';
        let initClass = 'intro';

        return '<div class="' + className + ' cols-count-'+ pagesArr.length +'">' +
                  '<div class="js-load-rive lottie js-play-rive-on-scrolled" '+
                        'data-init-animation="'+ initClass +'" ' +
                        'data-json="'+ pagesArr[index]['lottie'] +'" ' +
                        'data-name="swiper-naw-lottie-'+ index +'" >' +
                  '</div>' +
                  '<div class="line">' +
                    '<span class="progress"></span>' +
                    '<span class="hover"></span>' +
                  '</div>' +
                  '<div class="subtitle">'+ pagesArr[index]['title'] +'</div>' +
                '</div>'
      },
    },
    on: {
      afterInit: function () {
        // hack to start loading and json animation
        let activeNavEl = $('.swiper-pagination-bullet-active')
        activeNavEl.removeClass('swiper-pagination-bullet-active')

        setTimeout(function(){
           activeNavEl.addClass('swiper-pagination-bullet-active')
        }, 100)

        lastActiveAnimation = block.find('.js-load-rive[data-name="swiper-naw-lottie-' + this.realIndex + '"]')
      },
      slideChange: function () {
        let realSlideIndex = this.realIndex
        let activeAnimation = block.find('.js-load-rive[data-name="swiper-naw-lottie-' + realSlideIndex + '"]')

        playRive(activeAnimation, 'hover in')
        if (lastActiveAnimation) playRive(lastActiveAnimation, 'hover out')
        lastActiveAnimation = activeAnimation

        // stop prev slide video and play current left slider video
        $(leftSwiper.el).find('video').each(function(i, el) {
          //$(el).find('source').attr('src', '')
          // el.pause()
          // el.currentTime = 0
        })
        let curSLide = $(leftSwiper.slides[this.activeIndex])
        let video = curSLide.find('video')
        if (video.length){
          //video.find('source').attr('src', video.attr('data-img-src'))
          //video[0].play()
        }
      },

    },
  })

  rightSwiper.autoplay.stop()
  let active_bullet = $('.swiper-pagination-bullet-active')
  setTimeout(function(){
    active_bullet.removeClass('swiper-pagination-bullet-active')
  }, 500)


  ScrollTrigger.create({
    trigger: block[0],
    start: "bottom bottom",
    onEnter: () => {
      rightSwiper.autoplay.start()
      active_bullet.addClass('swiper-pagination-bullet-active')
    },

  });



  block.find('.swiper-pagination-bullet').hover(function() {
    if (!$(this).hasClass('swiper-pagination-bullet-active')){
      playRive($(this).find('.js-load-rive'), 'hover in')
    }
  }, function() {
    if (!$(this).hasClass('swiper-pagination-bullet-active')) {
      playRive($(this).find('.js-load-rive'), 'hover out')
    }
  });

})
